import { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useLookup$1 from './useLookup.js';
import { registerLookup } from '../../modules/lookups/config.js';
import { lookupReset } from '../../modules/lookups/actions.js';
import { createAutoName } from '../../modules/utility/naming.js';

/**
 * A hook to register a temporary lookup for an API action and return its data.
 * Useful shortcut for single instances of components where caching is not important.
 * For multiple instances or shared components, and to gain the benefits of caching, prefer useLookup instead.
 * @param {function} action API action creator for requesting lookup data, receives lookup parameters
 * @param {*} params Optional, parameters that will be passed to the lookup action
 * @param {object} options Additional options for the request
 * @param {number} options.key Optional, unique key for the request. If omitted will be automatically generated from params, otherwise the default key of '0' will be used
 * @param {boolean} options.cache Optional, override the lookup cache setting
 * @param {number} options.cacheExpiry Optional, override the lookup cacheExpiry setting
 * @param {number} options.cacheLimit Optional, override the lookup cacheLimit setting
 * @param {function} options.transform Optional, override the lookup transform setting
 * @returns {[]} An array in the format: [lookupData, resetLookup]
 * @returns {object} `lookupData` The current data for the lookup: { loading, slowLoading, params, date, response, error }
 * @returns {function} `resetLookup` A function to reset the lookup and re-request new data
 */

var useLookupAction = function useLookupAction(action, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lookup = useRef();

  if (!lookup.current) {
    var name = createAutoName("useLookupAction/");
    lookup.current = registerLookup(name, action, options);
  }

  var dispatch = useDispatch();
  useEffect(function () {
    return function () {
      if (!lookup.current) return;
      dispatch(lookupReset(lookup.current));
      lookup.current.unregister();
    };
  }, []);
  return useLookup$1(lookup.current, params, options);
};

var useLookupAction$1 = useLookupAction;

export { useLookupAction$1 as default };
